var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sync_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sync_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.05q0 1.126.425 2.188T7.75 16.2l.25.25V15q0-.424.287-.713A.97.97 0 0 1 9 14q.424 0 .713.287.287.288.287.713v4q0 .424-.287.712A.97.97 0 0 1 9 20H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 19q0-.424.287-.712A.97.97 0 0 1 5 18h1.75l-.4-.35q-1.3-1.15-1.825-2.625A8.8 8.8 0 0 1 4 12.05Q4 9.7 5.2 7.787A8 8 0 0 1 8.425 4.85a.77.77 0 0 1 .737-.025q.388.175.513.575.125.375-.013.75-.137.375-.487.575a6.14 6.14 0 0 0-2.313 2.213A5.86 5.86 0 0 0 6 12.05m12-.1q0-1.126-.425-2.187Q17.15 8.7 16.25 7.8L16 7.55V9q0 .424-.287.713A.97.97 0 0 1 15 10a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 9V5q0-.424.287-.713A.97.97 0 0 1 15 4h4q.424 0 .712.287Q20 4.576 20 5q0 .424-.288.713A.97.97 0 0 1 19 6h-1.75l.4.35q1.225 1.225 1.788 2.662Q20 10.45 20 11.95q0 2.35-1.2 4.262a8 8 0 0 1-3.225 2.938.77.77 0 0 1-.737.025.9.9 0 0 1-.513-.575q-.125-.375.013-.75.137-.375.487-.575a6.14 6.14 0 0 0 2.313-2.212q.861-1.413.862-3.113"
  }))));
};
export default SvgSync;